import { CompanyLocationEndpoint, CompanyProfile } from '../types';

export default class CompanyLocationsSerializers {
  static toJSON(company: Pick<CompanyProfile, 'locations'>) {
    return {
      company_locations: company.locations?.map((location) => ({
        resource_id: location.resourceId,
        street: location.street,
        house_number: location.houseNumber,
        zip_code: location.zipCode,
        city: location.city,
        additional_info: location.additionalInfo,
        country: location.country,
      }))
    };
  }

  static toObject(payload: CompanyLocationEndpoint): {
    locations: CompanyProfile['locations'];
  } {
    return {
      locations: payload.company_locations?.map((location) => ({
        resourceId: location.resource_id,
        street: location.street,
        houseNumber: location?.house_number,
        zipCode: location?.zip_code,
        city: location?.city,
        additionalInfo: location?.additional_info,
        country: location?.country,
      }))
    };
  }
}
